import { Notification } from "@/types";

import { axios } from "../axios.instance";

export type DeleteNotificationRequest = {
  notificationId: Notification["id"];
};

export type DeleteNotificationResponse = null;

export const deleteNotification = async (params: DeleteNotificationRequest): Promise<DeleteNotificationResponse> => {
  const { data } = await axios.delete(`/notifications/${params.notificationId}/delete`);

  return data;
};
